import { usePage } from "@inertiajs/react";
import { Link } from "@inertiajs/react";
import { ChevronLeft } from "lucide-react";
import { useEffect } from "react";

import { AppSidebar } from "@/components/app-sidebar";
import { LegalFooter } from "@/components/shared/LegalFooter";
// import { Notifications } from "@/components/partner/Notifications";
import { Button } from "@/components/ui/button";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/sonner";
import { useFlash } from "@/hooks/use-flash";
import { toast } from "@/hooks/use-toast";

const PartnerLayout = ({ children, backButton }) => {
  const {
    props: { flash, user },
  } = usePage();
  console.log("usePage", usePage());

  useEffect(() => {
    if (flash && flash.alert) {
      toast({
        title: "Alert",
        description: flash.alert,
        variant: "destructive",
      });
    }
    if (flash && flash.notice) {
      toast({
        title: "Notice",
        description: flash.notice,
        variant: "success",
      });
    }
  }, [flash]);

  useFlash();

  return (
    <SidebarProvider>
      <AppSidebar user={user} />
      <SidebarInset>
        <header className="flex h-12 shrink-0 items-center justify-between gap-2 bg-stone-50 px-4 backdrop-blur-xl transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
          <div className="flex items-center gap-2">
            <SidebarTrigger className="-ml-1" />
            {backButton && (
              <Button asChild size="sm" variant="ghost" className="h-8 gap-1">
                <Link href={backButton.href}>
                  <ChevronLeft className="h-4 w-4" />
                  <span className="whitespace-nowrap">{backButton.text}</span>
                </Link>
              </Button>
            )}
          </div>
          <div className="flex items-center gap-2">{/* <Notifications /> */}</div>
        </header>
        <div className="flex min-h-[calc(100vh-3rem)] flex-col bg-stone-50">
          <div className="max-w-full flex-1 bg-stone-50 px-2 py-1 pb-4 md:max-w-7xl md:px-6 md:py-1">
            <Toaster richColors closeButton position="top-right" />
            {children}
          </div>
          <LegalFooter className="mt-auto border-t border-stone-200 bg-stone-100" />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default PartnerLayout;
